import { CropTypeDtoSchema } from "@campaign/data/dto/crop-type.dto";
import * as z from "zod";

export enum PathogenTypeEnumDto {
    HONGO = "hongo",
    BACTERIA = "bacteria",
    VIRUS = "virus",
    INSECTO = "insecto",
}

export const AgentDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
        code: z.string().trim(),
        description: z.string().trim(),
        pathogen_type: z.enum(PathogenTypeEnumDto).nullable(),
        crop_types: z.array(CropTypeDtoSchema).optional(),
    })
    .readonly();
export type AgentDto = z.output<typeof AgentDtoSchema>;
